import type { BaseQueryApi } from '@reduxjs/toolkit/query'

import { connectorAPI } from 'actions/connector'
import { CONSTS } from 'config/objectConst'
import { appConnector } from 'shared/connector'
import {
	adaptPromiseForRTK,
	shouldUseRegularFetch
} from 'shared/connector/rtk-adapt'

import type { AttachmentProps } from '../model/types'

function fetchAttachments(
	{ accepts, id, url }: AttachmentProps,
	{ signal }: BaseQueryApi
) {
	url = encodeURIComponent(url)

	const promise = shouldUseRegularFetch()
		? fetchAttachmentsPure({
				accepts,
				id,
				signal,
				url
			})
		: appConnector.linkedIn.conversations.getConversationAttachment(
				id,
				url,
				accepts
			)

	return adaptPromiseForRTK(promise)
}

async function fetchAttachmentsPure({
	accepts,
	id,
	signal,
	url
}: AttachmentProps & { signal?: AbortSignal }) {
	const token = await connectorAPI.getAccessToken()
	const response = await fetch(
		`${CONSTS.API.URL_AUTOMATION}conversations/${id}/attachments/${url}`,
		{
			headers: {
				Accept: accepts,
				Authorization: token
			},
			method: 'GET',
			signal
		}
	)

	const blob = await response.blob()

	return URL.createObjectURL(blob)
}

export { fetchAttachments }
